import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IFootballMatchTeams } from "../../../../../../commons/models/football/interface/i-football-match";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { FootballMatchTeams } from "../../../../../../commons/models/football/football-match-teams";
import { manageFootballSeasonService } from "../../../../../../commons";
import { EnsueCollection } from "../../../../../../ensue-react-system/utilities/ensue-collection";
import { FootballTeamPlayer } from "../../../../../../commons/models/football/football-team-player";

export interface IManageMatchTeamPlayersOption {
  seasonId: number;
  matchId: number;
  teamId: number;
  urlParams?: {
    hostTeamId?: number;
  };
}

export interface IFootballManageMatchTeamPlayersState {
  manageMatchTeamPlayers: EnsueCollection<FootballTeamPlayer>;
  manageMatchTeamPlayersStatus: StatusEnum;
}

const initialState: IFootballManageMatchTeamPlayersState = {
  manageMatchTeamPlayers: new EnsueCollection<FootballTeamPlayer>(),
  manageMatchTeamPlayersStatus: StatusEnum.Idle,
};

export const fetchManageMatchTeamPlayers = createAsyncThunk(
  "manageMatchTeams/fetchManageMatchTeamPlayers",
  async (options: IManageMatchTeamPlayersOption, thunkAPI) => {
    try {
      const manageMatchTeams = await manageFootballSeasonService.getSeasonMatchTeamPlayers(
        options.seasonId,
        options.matchId,
        options.teamId,
        options.urlParams
      );
      return manageMatchTeams;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageMatchTeamPlayersSlice = createSlice({
  name: "footballManageMatchTeamPlayers",
  initialState: initialState,
  reducers: {
    cleanUpMatchTeamPlayers(state) {
      state.manageMatchTeamPlayers = new EnsueCollection<FootballTeamPlayer>();
      state.manageMatchTeamPlayersStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageMatchTeamPlayers.pending, (state) => {
        state.manageMatchTeamPlayersStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageMatchTeamPlayers.fulfilled,
        (state, action: PayloadAction<EnsueCollection<FootballTeamPlayer>>) => {
          state.manageMatchTeamPlayersStatus = StatusEnum.Succeeded;
          state.manageMatchTeamPlayers = action.payload;
        }
      )
      .addCase(fetchManageMatchTeamPlayers.rejected, (state) => {
        state.manageMatchTeamPlayersStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpMatchTeamPlayers } = footballManageMatchTeamPlayersSlice.actions;
export default footballManageMatchTeamPlayersSlice.reducer;
